import { css } from "@emotion/css";
import { ScheduleAppointmentTypes } from "molecule/scheduler/SchedulerBloc";
import type { FC } from "react";
import React from "react";
import translate from "src/lib/translate";
import InDialog from "src/ui/components/InDialog/InDialog";
import AppointmentScheduler from "../../AppointmentScheduler/AppointmentScheduler";
import { AppQueryPopupsController } from "../AppQueryPopupsBloc";

const ionModalStyles = css`
  // popup options for iframe
  ion-content {
    --padding-start: 0;
    --padding-end: 0;
  }
`;

const ScheduleAppointmentDialog: FC<{
  returnUrl: string;
}> = ({ returnUrl }) => {
  const searchParams = new URLSearchParams(location.search);
  const rescheduleId = searchParams.get("reschedule") as string | undefined;
  const appointmentType = searchParams.get("type") as
    | ScheduleAppointmentTypes
    | undefined;
  const reschedulingRequiredParam = searchParams.get("reschedulingRequired");
  const reschedulingRequired =
    reschedulingRequiredParam !== null
      ? reschedulingRequiredParam === "true"
      : undefined;

  const onClose = () => {
    AppQueryPopupsController.closePopup();
  };

  return (
    <InDialog
      popup
      title={translate(
        rescheduleId
          ? "title.rescheduleAppointment"
          : "title.scheduleAppointment"
      )}
      onClose={onClose}
      returnUrl={returnUrl}
      className={ionModalStyles}
      width="min(calc(100% - 4rem), 520px)"
      height="min(calc(100% - 4rem), 80vh)"
      background="gradient"
    >
      <AppointmentScheduler
        type={appointmentType}
        rescheduleId={rescheduleId}
        reschedulingRequired={reschedulingRequired}
        onScheduled={onClose}
      />
    </InDialog>
  );
};

export default ScheduleAppointmentDialog;
